/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Welcome_Phase_Rmf_InitializingInputs */

const en_welcome_phase_rmf_initializing = /** @type {(inputs: Welcome_Phase_Rmf_InitializingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bringing up the RMF stack`)
};

const fr_welcome_phase_rmf_initializing = /** @type {(inputs: Welcome_Phase_Rmf_InitializingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Démarrage de la stack RMF`)
};

const ms_sg2_welcome_phase_rmf_initializing = /** @type {(inputs: Welcome_Phase_Rmf_InitializingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menyediakan stack RMF`)
};

/**
* | output |
* | --- |
* | "Bringing up the RMF stack" |
*
* @param {Welcome_Phase_Rmf_InitializingInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const welcome_phase_rmf_initializing = /** @type {((inputs?: Welcome_Phase_Rmf_InitializingInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_Phase_Rmf_InitializingInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_welcome_phase_rmf_initializing(inputs)
	if (locale === "fr") return fr_welcome_phase_rmf_initializing(inputs)
	return ms_sg2_welcome_phase_rmf_initializing(inputs)
});